export default __webpack_public_path__ + "static/get-debt-help-settlement-5ee5396d01d67fa16993028a3d561314.svg";